import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

interface SettingsHeaderProps {
  headerText: string;
  subText: string;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ headerText, subText }) => {
  return (
    <div className="bg-surface border-b border-strong flex flex-col justify-center pl-6 py-6">
      <Title level={3} style={{ marginBottom: 4 }}>
        {headerText}
      </Title>
      <Text type="secondary">{subText}</Text>
    </div>
  );
};

export default SettingsHeader;
